import "@/scripts/helpers/polyfills";
import "@/scripts/signnowHeader";
import MainFooter from "@/modules/layout/page-footer/page-footer";
// import Offcanvas from "@/modules/layout/offcanvas/offcanvas";
import BannerHeader from "@/modules/banner-header/index";
import smartBanner from "@/modules/banner-header/smart-app-banner";

import { handleParsleyActions, initCustomSelectPlugin } from "@/scripts/helpers/parsleyValidation";
import {
  attachIE11helper,
  attachEdgeBrowserHelper,
  attachSafariBrowser,
  attachFirefoxBrowser,
  bindJQuery
} from "@/scripts/helpers/library";

bindJQuery();

$(document).ready(function() {
  // Offcanvas();
  // Modal();
  attachIE11helper();
  attachEdgeBrowserHelper();
  attachSafariBrowser();
  attachFirefoxBrowser();
  MainFooter();
  handleParsleyActions();
  initCustomSelectPlugin();
  BannerHeader();
  
  setTimeout(() => {
    smartBanner();
  }, 4000); 
});

